import { render } from "./StayWrapper.vue?vue&type=template&id=9092c268"
import script from "./StayWrapper.vue?vue&type=script&lang=js"
export * from "./StayWrapper.vue?vue&type=script&lang=js"
script.render = render

export default script